import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreEffects } from '@pit/core-store';
import { IDtoUserRole } from '@pit/frontend-model';
import { DtoUserRoleStoreFactory } from './dto.user.role.store.factory';

@Injectable()
export class DtoUserRoleEffects extends EntityStoreEffects<IDtoUserRole> {

    constructor(actions$: Actions, dataServiceAccessor: EntityDataServiceAccessorService) {
        super('dto.user.role', actions$, DtoUserRoleStoreFactory.instance, dataServiceAccessor);
    }

}
